// Libs
import PropTypes from 'prop-types';
// Components
import Entity from '../entity/Entity';
import Icon from '../icon/Icon';
import IconTooltip from '../iconTooltip/IconTooltip';
import { Card, CardContent } from '../../ui/card';
import { Skeleton } from '../../ui/skeleton';
// Common
import ICONS from '@/common-utils/enums/icons';

/**
 * @param {Object} props
 * @param {JSX} props.valueContent
 * @param {boolean} props.isLoading
 * @param {string} props.label
 * @param {string} props.icon
 * @param {string} props.tooltip
 * @param {string} props.namespace
 * @returns {JSX} StatsChart
 */
function StatsChart({ valueContent, isLoading = false, label = '', icon, tooltip = '', namespace = '' }) {

    return (
        <Card className='min-w-[200px]  border border-gray-300'>
            <CardContent className='flex flex-col items-start gap-2 py-2 px-4'>
                {isLoading ? (
                    <div className='flex flex-col items-start gap-2 w-full'>
                        <div className='flex items-center gap-2'>
                            <Skeleton className='w-8 h-8' />
                            <Skeleton className='w-32 h-8' />
                        </div>
                        <Skeleton className='w-16 h-4' />
                    </div>
                ) : (
                    <>
                        <div className='flex items-center gap-2'>
                            <Icon icon={icon} />
                            {valueContent}
                        </div>
                        <div className='flex items-center gap-2'>
                            <Entity
                                entity={label}
                                namespace={namespace}
                                className='text-sm font-semibold text-muted-foreground'
                            />
                            <IconTooltip icon={ICONS.HELP} tooltipEntity={tooltip} namespace={namespace} />
                        </div>
                    </>
                )}
            </CardContent>
        </Card>
    );
}

StatsChart.propTypes = {
    valueContent: PropTypes.element,
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    icon: PropTypes.string,
    tooltip: PropTypes.string,
    namespace: PropTypes.string
};

export default StatsChart;